import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
    constructor(private router: Router) {}
    ngOnInit(): void {
    }
    
    goToContact(): void {
        this.router.navigate(['/contact']).then(() => {
            // Always move contact page to the top
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 50);
        });
    }
    goToAbout(): void {
        this.router.navigate(['/about']).then(() => {
            // Always move about page to the top
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 50);
        });
    }
}